
import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SelectionService from "../../../services/SelectionService";
import EmptyTimesView from "../times/EmptyTimesView";
import AddTimeView from "../times/AddTimeView";
import TimesListView from "../times/TimesListView";
import StepperNav from "../StepperNav";
import { useLocation } from "react-router-dom";
import config from "../../../config";
import axios, { all } from "axios";
import dayjs from "dayjs";


const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;
function Times() {
  const [view, setView] = useState("empty"); // empty, add, list
  const [times, setTimes] = useState([]);
  const [selectedTimeIndex, setSelectedTimeIndex] = useState(null);
  const [loading, setLoading] = useState(false); 
  const navigate = useNavigate();
  const location = useLocation();
  const userId= location.state?.userId;
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading
      try {
        console.log("Fetching data for userId:", userId); // Log the userId being used
        const response = await axios.get(`${API_URL}/report_times/user/${userId}`, {
          headers: {
            "X-API-Key": API_TOKEN,
          },
        });
        console.log("Fetched data:", response.data); // Log the fetched data
        if (response.data.length > 0) {
          setTimes(response.data);
          SelectionService.setTimes(response.data);
          if (view === "empty") setView("list");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }finally {
        setLoading(false); // Stop loading
      }
    };

    fetchData();

    const savedIndex = SelectionService.getSelectedTime();

    if (savedIndex !== null) setSelectedTimeIndex(savedIndex);
  }, []);

  const transformTimeObject = (input) => ({
    name: input.title,
    from: dayjs(input.from[0]).format("HH:mm"),
    to: dayjs(input.from[0]).format("HH:mm"),
    userId: userId,
    allDay: input.allDay,
  });
  const handleAddTime = () => setView("add");

  const handleSaveTime = async (newTime) => {
    if (!newTime) {
      setView(dates.length > 0 ? "list" : "empty");
      return;
    }
  
    try {
      console.log("Saving new time:", newTime); 
      const formattedTime = transformTimeObject(newTime);
  
      const response = await axios.post(`${API_URL}/report_times`, formattedTime, {
        headers: {
          "X-API-Key": API_TOKEN,
          "accept": "*/*",
          "Content-Type": "application/json"
        }
      });
      console.log("Response from server:", response.data); // Log the response from the server
      const updatedTimes = [...times, newTime];
      setTimes(updatedTimes);
      SelectionService.setTimes(updatedTimes);
      setView("list");
  
    } catch (error) {
      console.error("Error saving date:", error);
    }
  };



  const handleDeleteTime = async (index) => {
    const timeToDelete = SelectionService.getTimes()[index];
    console.log("time to delete", timeToDelete);
  
    try {
      const response = await axios.delete(`${API_URL}/report_times/${timeToDelete.id}`, {
        headers: {
          "X-API-Key": API_TOKEN,
          "accept": "*/*",
          "Content-Type": "application/json"
        }
      });
  
      
      SelectionService.deleteTime(index);
      SelectionService.resetSelectedTimeIndex(index);
      setSelectedTimeIndex(SelectionService.getSelectedTime());
      const updatedDates = SelectionService.getTimes();
      setTimes(updatedDates);
      setView("list");
  
      if (updatedDates.length === 0) {
        setView("empty");
      }
  
    } catch (error) {
      console.error("Error deleting date:", error);
    }
  };

  const handleSelectTime = (index) => {
    setSelectedTimeIndex(index);
    SelectionService.setSelectedTime(index);
  };

  const handleProceedToNextStep = () => {
    navigate("/trajectories/link",{ state: { userId: userId } }); // Proceed to the next step
  };

  const handleProceedToPreviousStep = () => {
  
  navigate("/trajectories/dates", { state: { userId: userId } });// Go back to the previous step
  };

  return (
    <DashboardLayout>
      <Grid container direction="row" sx={{ alignItems: "stretch", height: "87vh" }}>
        <Box sx={{ width: "30%", height: "87vh", display: "flex", flexDirection: "column" }}>
          <Grid container direction="column" sx={{ flex: 1 }} >
          <Grid item xs={8} sx={{ flexGrow: 1 }}>
            {view === "empty" && <EmptyTimesView onAddTime={handleAddTime} />}
            {view === "add" && <AddTimeView onSave={handleSaveTime} />}
            {view === "list" && (
              <TimesListView
                times={times}
                selectedTimeIndex={selectedTimeIndex}
                onDelete={handleDeleteTime}
                onSelect={handleSelectTime}
                onAddTime={handleAddTime}
              />
            )}
            </Grid>
            <Grid item 
            xs="auto"
            sx={{
            mt: "auto", // Pushes the grid to the bottom of the container
            textAlign: "right", // Aligns buttons to the right
            }}>
         <Grid container justifyContent="flex-end" spacing={2}>
         <Grid item>
              <MDButton 
                variant="outlined"
                color="info"
                size="medium"  onClick={handleProceedToPreviousStep}>
                Back
              </MDButton>
              </Grid>
              <Grid item>
              <MDButton
                variant="contained"
                color="info"
                size="medium"
                disabled={selectedTimeIndex === null}
                onClick={handleProceedToNextStep}>
                Next
              </MDButton>
              </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ flex: 1 }}>
          <StepperNav />
        </Box>
      </Grid>
    </DashboardLayout>
  );
}

export default Times;
